import React from "react";

export const HeaderNav: React.FC = () => {
  return <h2>KWC Bakken</h2>;
};

export default HeaderNav;
